import script from "./VueIntersect.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueIntersect.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__